import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import ServiceCard from "@/components/ServiceCard";
import CtaSection from "@/components/CtaSection";
import { SERVICES } from "@/data/site";

export default function Services() {
    return (
        <div>
            <Seo
                title="Services | The Sens Civil Works Consultancy — Gorakhpur"
                description="Construction & renovation consultancy, site inspection, contractor bill checking, BOQ & quantity verification, estimate review, maintenance planning, tender documentation and landscaping consultancy in Gorakhpur, UP."
            />
            <PageHero
                overline="Services"
                title="Independent Consultancy, End to End"
                description="Eight focused services built around one purpose: helping you make better construction decisions with independent technical backing."
            />
            <section className="blueprint-grid bg-background py-20 lg:py-28" data-testid="services-grid">
                <div className="mx-auto max-w-7xl px-6 lg:px-12">
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                        {SERVICES.map((s, i) => (
                            <ServiceCard key={s.title} service={s} index={i} />
                        ))}
                    </div>
                </div>
            </section>
            <CtaSection
                overline="Not Sure Which Service?"
                title="Describe Your Situation — We'll Guide You"
                description="A short conversation is usually enough to identify the right scope: a site visit, a document review, or ongoing project support."
            />
        </div>
    );
}
